"use client";
import GoogleTranslate from "@/layout/GoogleTranslate";
import Link from "next/link";
import React from "react";
import { BiMailSend, BiPhone } from "react-icons/bi";

const AddressInfo = () => {
  return (
    <div className="bg-primary-main py-3 ">
      <div className="container ">
        <div className="grid grid-cols-1 ">
          <div className="flex justify-end gap-4 ">
            <Link
              href="tel:+919210903903"
              className="flex items-center text-white font-medium  text-sm hover:text-primary-light "
            >
              <span>
                <BiPhone className="mr-2 text-xl" />
              </span>
              +91 92109 03903
            </Link>
            <span className=" w-[1px] h-full bg-white "></span>
            <Link
              href="mailto:response@prestogroup.com"
              className="flex items-center text-white font-medium  text-sm hover:text-primary-light "
            >
              <span>
                <BiMailSend className="mr-2 text-xl" />
              </span>
              response@prestogroup.com
            </Link>
            <span className=" w-[1px] h-full bg-white "></span>

            <GoogleTranslate />
          </div>
          {/* <div className="flex justify-end gap-5">
            <Link href="https://twitter.com/PrestoGroup/" target="_blank">
              <BiLogoTwitter className="mr-2 text-xl text-white  hover:text-primary-light " />
            </Link>

            <Link href="https://www.facebook.com/prestogroup/" target="_blank">
              <BiLogoFacebook className="mr-2 text-xl text-white  hover:text-primary-light " />
            </Link>

            <Link
              href="https://www.linkedin.com/company/prestogroup/"
              target="_blank"
            >
              <BiLogoLinkedin className="mr-2 text-xl text-white  hover:text-primary-light " />
            </Link>

            <Link href="https://www.pinterest.com/prestogroup/" target="_blank">
              <BiLogoPinterest className="mr-2 text-xl text-white  hover:text-primary-light " />
            </Link>
            <Link href="https://www.youtube.com/user/GroupPresto/" target="_blank">
              <BiLogoYoutube className="mr-2 text-xl text-white  hover:text-primary-light " />
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AddressInfo;
